






































import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import { AddToCartProcessStateStore } from '@/components/interactions/cart/add-to-cart/add-to-cart-process-state-store'
import { BrandRouteResolver } from '@/util/brandRouteResolver'
import { InstanceResolver } from '@/util/instanceResolver'
import { AddToCartButtonEligibilityChecker } from '@spa/components/organisms/mypage/order/model/add-to-cart-button'
import OrderHistoryAddToCartButton from '@spa/components/organisms/mypage/order/OrderHistoryAddToCartButton.vue'
import { PluginMixin } from '@spa/mixins/plugin'
import { Product } from '@spa/store/modules/orderHistory/types'

@Component({
  components: {
    OrderHistoryAddToCartButton,
  },
})
export default class OrderProduct extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  readonly product: Product

  @Prop({ required: true })
  readonly addToCartButtonEligibilityChecker: AddToCartButtonEligibilityChecker

  @Prop({ required: true })
  readonly addToCartProcessStateStore: AddToCartProcessStateStore

  /**
   * 商品画像から商品詳細画面へリンクするか.
   *
   * ROOTが取得できる商品（商品詳細が存在する商品）のみリンクする.
   * ノベルティ・カタログは商品詳細画面を閲覧される想定の商品種別ではないためリンクしない.
   * @see https://github.com/Everforth/growthpalette-front/issues/9062
   */
  get shouldLinkToItemDetail(): boolean {
    return !!this.product.rootId && !this.product.isNovelty && !this.product.isCatalogType
  }

  get itemDetailLink(): string {
    const endpoint = BrandRouteResolver.makeResourceEndpoint({
      brand: this.product.brandEnglishName || '' ,
      path: [
        'item',
        this.product.rootId || '',
      ],
      query: {
        color: this.product.alphabeticColor,
      },
    })

    return endpoint
  }

  isAddToCartButtonEnabled(product: Product): boolean {
    return this.addToCartButtonEligibilityChecker({ product })
  }

  formatPrice(price: number): string {
    return price.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' })
  }

  get shouldShowBrand(): boolean {
    return InstanceResolver.isMulti()
  }
}
